import { createFileRoute } from "@tanstack/react-router";
import { DenomLandingPage } from "@/components/prize-bond/DenomLandingPage";
import { buildPrizeBondLandingHead } from "@/lib/prize-bond-landing-head";

const DENOM = 1500;
const SLUG = "prize-bond-1500-result-today";
const TITLE =
  "Prize Bond 1500 Result Today 2026 - Prize Bond Check Karne Ka Tarika - Check Prize Bond Online";
const DESC =
  "Rs. 1,500 wale prize bond ki list aaj — first prize Rs. 30 lakh. Online single, bulk, range checker with official National Savings data.";

const HOW_TO_STEPS = [
  { title: "Rs. 1,500 chip select karein", body: "Denomination bar mein pink Rs. 1,500 chip par tap karein — mid-range bearer bond, sab ke liye open." },
  { title: "Bond number likhein", body: "Rs. 1,500 bond ke upper right corner mein 6-digit serial hota hai — wohi input mein daalein." },
  { title: "Mode choose karein", body: "Ek bond = Single tab. Kayi bonds = Bulk (100 max). Consecutive serial = Range (500 max)." },
  { title: "Green Check dabayein", body: "Winners green highlight aur celebration animation ke sath show hote hain, non-winners neeche list mein aa jate hain." },
  { title: "Claim SBP branch se", body: "Draw ke 6 saal ke andar SBP Banking Services branch mein bond, CNIC copy, aur claim form jama karayein — bara inaam cross cheque mein milega." },
];

const FAQS = [
  { q: "1500 wale prize bond ki list aaj kahan milegi?", a: "Upar checker mein Rs. 1,500 chip select karein aur bond number likh kar 'Check Karain' dabayein. Data National Savings Pakistan ki official Rs. 1,500 draw PDF se sync hota hai — draw ke 24 hours ke andar update ho jata hai." },
  { q: "Rs. 1,500 prize bond ka first prize kitna hai?", a: "First prize Rs. 30,00,000 (30 lakh) — 1 winner. Second prize Rs. 10,00,000 (10 lakh) — 3 winners. Third prize Rs. 18,500 — 1,696 winners. Yeh Rs. 750 ka double jackpot deta hai." },
  { q: "1500 prize bond draw kab hoti hai?", a: "Rs. 1,500 draw quarterly hoti hai — usually February, May, August, November mein. Exact tareekh National Savings 15-20 din pehle official calendar par publish karta hai." },
  { q: "Kya Rs. 1,500 bearer hai?", a: "Haan, Rs. 1,500 bearer bond hai — CNIC ya registration ki zarurat nahi. Koi bhi cash mein SBP ya commercial bank ki kisi branch se le ya wapis surrender kar sakta hai." },
  { q: "Rs. 1,500 bond ka color kya hai?", a: "Rs. 1,500 bond ka color pink hota hai — is se doosri denominations se pehchan mein aasani hoti hai. Yeh 2009 mein introduce kiya gaya tha aur ab tak bearer form mein continue hai." },
  { q: "1500 par tax kitna lagta hai?", a: "Third prize Rs. 18,500 par filer ko 15% (Rs. 2,775) tax katke Rs. 15,725 milega. Non-filer ko 30% (Rs. 5,550) katke Rs. 12,950 net milega. Bara inaam par bhi same rates hain." },
  { q: "Rs. 1,500 vs Rs. 750 — kaunsa behtar hai?", a: "Rs. 1,500 ka jackpot Rs. 30 lakh, Rs. 750 ka Rs. 15 lakh — double. Per-bond cost bhi double, isliye same capital mein aap adhi quantity rakh sakte hain. Diversification chahiye to Rs. 750, bara jackpot per bond chahiye to Rs. 1,500." },
  { q: "1500 wala prize bond kahan se milta hai?", a: "SBP Banking Services Corporation aur authorized commercial banks (HBL, MCB, UBL, ABL, NBP, Bank Alfalah, Meezan) ki branches se cash payment par milta hai — koi form ya CNIC copy ki zarurat nahi." },
  { q: "Kya Rs. 1,500 bond par 6-monthly profit milta hai?", a: "Nahi — Rs. 1,500 bearer bond hai, is par sirf prize draw wali chance-based income hoti hai. 6-monthly profit sirf premium bonds (Rs. 25,000 aur Rs. 40,000) par milti hai." },
  { q: "Rs. 1,500 ki purani draws bhi checker mein check hoti hain?", a: "Haan — jo bhi Rs. 1,500 historical draws upload hui hain, un sab ke against aap ke numbers automatically match hote hain. Multiple wins alag alag cards mein show hoti hain draw # aur city ke saath." },
];

const RELATED = [
  { href: "/prize-bond-list-750-today", label: "Rs. 750 Prize Bond" },
  { href: "/prize-bond-100-result-today", label: "Rs. 100 Prize Bond" },
  { href: "/prize-bond-200-result-today", label: "Rs. 200 Prize Bond" },
  { href: "/prize-bond-25000-result-today", label: "Rs. 25,000 Premium" },
  { href: "/prize-bond-40000-result-today", label: "Rs. 40,000 Premium" },
  { href: "/prize-bond", label: "All Prize Bonds Hub" },
];

export const Route = createFileRoute("/prize-bond-1500-result-today")({
  head: () =>
    buildPrizeBondLandingHead({
      slug: SLUG,
      title: TITLE,
      description: DESC,
      denomination: DENOM,
      howToName: "How to check Rs. 1,500 Prize Bond result today",
      howToSteps: HOW_TO_STEPS,
      faqs: FAQS,
    }),
  component: Page,
});

function Page() {
  return (
    <DenomLandingPage
      denomination={DENOM}
      h1English="Prize Bond 1500 Result Today — Full Winners List & Online Checker"
      h1Hinglish="1500 Wale Prize Bond Ki List Aaj — Foran Result Check Karain"
      introParagraphs={[
        "Rs. 1,500 Pakistan ka popular mid-range bearer prize bond hai — jackpot Rs. 30 lakh ke sath, aur 1,700 total winners har draw mein. Yeh 2009 mein introduce hua tha aur ab tak Rs. 750 se ek step upar ke serious savers ke liye go-to option raha hai.",
        "Is page par upar diya checker seedha National Savings Pakistan ki official Rs. 1,500 draw PDF ke against match karta hai. Draw hone ke 24 hours ke andar hamara backend winners parse karke checker mein feed kar deta hai — matlab aap ko koi list PDF search karne, ya third-party WhatsApp forwards ka wait karne ki zarurat nahi.",
        "Neeche checker ke baad Rs. 1,500 ki full prize structure, tax math, Rs. 750 se comparison aur unique FAQs milengi — sirf isi denomination ke user context ke liye tailor kiya hua.",
      ]}
      keyFacts={[
        { label: "1st Prize", value: "Rs. 30,00,000" },
        { label: "2nd Prize (×3)", value: "Rs. 10,00,000" },
        { label: "3rd Prize (×1696)", value: "Rs. 18,500" },
        { label: "Color", value: "Pink · Bearer" },
      ]}
      sections={[
        {
          id: "1500-vs-750",
          heading: "Rs. 1,500 vs Rs. 750 — Detailed Comparison",
          body: (
            <>
              <p>
                Rs. 1,500 ki cost Rs. 750 se double hai, aur jackpot bhi exactly double (Rs. 30 lakh vs Rs. 15 lakh).
                Third prize Rs. 18,500 hai, jo Rs. 750 wale Rs. 9,300 ka almost double. Total winners tadaad dono
                mein ~1,700 hai, isliye per-bond winning probability approximately same rehti hai.
              </p>
              <p>
                Practically, agar aap ke pas fixed budget hai (jaise Rs. 30,000), to aap 20 Rs. 1,500 bonds ya 40 Rs. 750
                bonds rakh sakte hain. Rs. 750 wali strategy zyada diversified hai (double chances of any winning),
                lekin Rs. 1,500 mein har jeet ka amount double hai — matlab low-probability, high-payoff bet.
              </p>
            </>
          ),
        },
        {
          id: "1500-tax-math",
          heading: "Rs. 1,500 Ka Realistic Tax Math",
          body: (
            <>
              <p>
                Third prize Rs. 18,500 par filer ko Rs. 2,775 tax katke Rs. 15,725 milega — matlab bond ki original
                cost (Rs. 1,500) ka 10.5x return, aur non-filer ko 8.6x. Bara inaam Rs. 10 lakh par filer ko Rs. 8.5
                lakh net, non-filer ko Rs. 7 lakh net milega. Filer status prize bond investors ke liye financially
                significant advantage hai — long-term ROI mein 15-20% farq parta hai.
              </p>
            </>
          ),
        },
      ]}
      howToSteps={HOW_TO_STEPS}
      faqs={FAQS}
      relatedLinks={RELATED}
    />
  );
}
